import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';
import withCSRF from '../../commonComponents/withCSRF';
import { compose } from '../../services/utilityFunctions';
import SurveyProp from './propTypes/surveyProp';
import SurveyDisplay from './SurveyDisplay';
import Request from '../../services/request';
import Notifications from '../../services/notifications';
import SurveyNoQuestions from './SurveyNoQuestions';
import SurveyJSContainer from '../../commonComponents/surveyJS/SurveyJSContainer';

const provider = {
  SURVEYJS: 'surveyjs',
  BRAVON: 'bravon',
};

function SurveyDetails(props) {
  const {
    t,
    _csrf,
    redirectOnSubmit,
    survey,
    contextId,
    onDone,
    backURL,
    onSkipStep,
  } = props;
  const submitAnswers = answers => {
    let url = `/survey/${survey._id}/submit`;
    if (contextId) {
      url += `?context=${contextId}`;
    }
    new Request(_csrf)
      .post(url, { answers })
      .done(() => {
        Notifications.showNotificationSuccess(
          t('success'),
          t('survey_submitted'),
        );
        if (onDone) {
          onDone();
        }
        if (redirectOnSubmit && !onDone) {
          window.location.href = backURL || '/dashboard';
        }
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_surveySubmit');
      });
  };

  const questions = survey.questions || [];
  const sortedQuestion = questions.sort((s1, s2) => s1.position - s2.position);
  // Check the survey provider
  const isSurveyJS = survey && survey.providerType === provider.SURVEYJS;
  return (
    <>
      {/** PROVIDER TYPE === surveyjs */}
      {isSurveyJS &&
        (survey.surveyContext && !survey.surveyContext.isSubmitted ? (
          <SurveyJSContainer
            t={t}
            survey={survey}
            _csrf={_csrf}
            contextId={contextId}
            backURL={backURL}
            onDone={onDone}
            onSkipStep={onSkipStep}
          />
        ) : (
          <SurveyNoQuestions />
        ))}
      {/** PROVIDER TYPE === bravon or dont exist */}
      {!isSurveyJS &&
        (questions.length > 0 ? (
          <SurveyDisplay
            questions={sortedQuestion}
            onSurveyDone={submitAnswers}
            onSkipStep={onSkipStep}
          />
        ) : (
          <SurveyNoQuestions />
        ))}
    </>
  );
}

SurveyDetails.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  contextId: PropTypes.string,
  backURL: PropTypes.string,
  survey: PropTypes.shape(SurveyProp.propType).isRequired,
  redirectOnSubmit: PropTypes.bool,
  onDone: PropTypes.func,
  onSkipStep: PropTypes.func,
};

SurveyDetails.defaultProps = {
  contextId: null,
  backURL: null,
  redirectOnSubmit: true,
  onDone: null,
  onSkipStep: null,
};

export default compose(translate, withCSRF)(SurveyDetails);
